<template>
  <div class="payment-banner">
    <img :src="img_gopay_color" class="ml-2" style="height: 40px" alt="" />
    <img :src="img_visa_verif" class="ml-2" style="height: 40px" alt="" />
    <img :src="img_mc_sec" class="ml-2" style="height: 40px" alt="" />
    <img :src="img_visa_white" class="ml-2" style="height: 40px" alt="" />
    <img :src="img_visa_color" class="ml-2" style="height: 40px" alt="" />
    <img :src="img_mc_white" class="ml-2" style="height: 40px" alt="" />
    <img :src="img_mc_elec" class="ml-2" style="height: 40px" alt="" />
    <img :src="img_maestro" class="ml-2" style="height: 40px" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      img_gopay_color: require("../assets/gopay_color.png"),
      img_visa_verif: require("../assets/visa_verified.png"),
      img_mc_sec: require("../assets/mc_secure.png"),
      img_visa_white: require("../assets/visa_white.png"),
      img_visa_color: require("../assets/visa_color.png"),
      img_mc_white: require("../assets/mc_white.png"),
      img_mc_elec: require("../assets/mc_elec.png"),
      img_maestro: require("../assets/maestro.png"),
    };
  },
};
</script>
